const PRIORITIZE_NUDGE_TIMESTAMP_PREFIX = 'mail_priority_inbox_nudge_timestamp';

function getPrioritizeNudgeTimestampKey(mailboxSmtpAddress: string): string {
    return `${PRIORITIZE_NUDGE_TIMESTAMP_PREFIX}_${mailboxSmtpAddress}`;
}

export { PRIORITIZE_NUDGE_TIMESTAMP_PREFIX, getPrioritizeNudgeTimestampKey };
